import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { TRY } from "@/lib/api";
import { Card } from "@/components/Cards";

const COLORS = { CIG_GIDER: "#E27D38", GENEL_GIDER: "#8B7CF6", OZEL_GIDER: "#FB7185", BANKA_GIDER: "#60A5FA", KOMISYON: "#F59E0B", PERSONEL: "#38BDF8", LOJISTIK: "#FBBF24", AMBALAJ: "#A78BFA", BAKIM: "#F472B6", VERGI: "#F87171", DIGER_GIDER: "#9CA3AF", TAHSILAT: "#34D399", DIGER_GELIR: "#6EE7B7" };

export default function CashGroupChart({ summary, period }) {
  const groups = summary.by_group;
  const monthly = period === "6m" || period === "12m";
  const months = monthly ? (() => { const out = []; let [y, m] = summary.start.slice(0, 7).split("-").map(Number); const [ey, em] = summary.end.slice(0, 7).split("-").map(Number); const byM = Object.fromEntries(summary.by_month.map((x) => [x.month, x])); while (y < ey || (y === ey && m <= em)) { const k = `${y}-${String(m).padStart(2, "0")}`; out.push(byM[k] || { month: k, income: 0, expense: 0, net: 0 }); m++; if (m > 12) { m = 1; y++; } } return out; })() : [];
  const series = monthly ? months.map((m) => ({ ...m, label: m.month.slice(5) + "/" + m.month.slice(2, 4) })) : summary.by_day.map((d) => ({ ...d, label: d.date.slice(8) }));
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
      <Card className="p-5" data-testid="cashbook-groups">
        <h3 className="font-heading text-lg font-semibold mb-3">Grup Dağılımı</h3>
        {groups.length === 0 ? <div className="py-8 text-center text-sm text-muted-foreground" data-testid="cashbook-groups-empty">Bu dönemde kayıt yok</div> : (
          <div className="space-y-2.5">
            {groups.map((g) => (
              <div key={g.group} data-testid={`cashbook-group-${g.group}`}>
                <div className="flex items-center justify-between text-sm">
                  <span className="flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORS[g.group] || "#999" }} />{g.label}<span className="text-xs text-muted-foreground">· {g.count} kayıt</span></span>
                  <span className={`font-mono font-semibold ${g.kind === "income" ? "text-emerald-400" : ""}`}>{TRY(g.total)} <span className="text-xs text-muted-foreground">%{g.share}</span></span>
                </div>
                <div className="mt-1 h-1.5 rounded-full bg-muted overflow-hidden"><div className="h-full rounded-full" style={{ width: `${g.share}%`, background: COLORS[g.group] || "#999" }} /></div>
              </div>
            ))}
          </div>
        )}
      </Card>
      {period !== "day" && (
        <Card className="p-5" data-testid="cashbook-trend">
          <h3 className="font-heading text-lg font-semibold mb-3">{monthly ? "Aylık" : "Günlük"} Gelir / Gider</h3>
          <div className="h-56">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={series} margin={{ left: 0, right: 8, top: 4, bottom: 0 }}>
                <XAxis dataKey="label" tick={{ fontSize: 11 }} stroke="currentColor" opacity={0.5} />
                <YAxis tick={{ fontSize: 11 }} stroke="currentColor" opacity={0.5} tickFormatter={(v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : v)} width={40} />
                <Tooltip formatter={(v) => TRY(v)} contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }} />
                <Bar dataKey="income" name="Gelir" fill="#34D399" radius={[4, 4, 0, 0]} />
                <Bar dataKey="expense" name="Gider" fill="#F87171" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>
      )}
    </div>
  );
}
